import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button/Button';
import { Modal } from '../../Modal/Modal';

/**
 * ConfirmDialog - A modal confirmation dialog for Gigabot
 *
 * Replaces window.confirm() with a styled modal that matches the Gigabot design.
 */
export const ConfirmDialog = ({
  isOpen,
  title = 'Confirm',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger',
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size='sm'
      closeOnOverlayClick={false}
      showFooter={false}
    >
      <div className='confirm-dialog'>
        <h3 id='confirm-dialog-title' className='confirm-dialog__title'>
          {title}
        </h3>
        <div id='confirm-dialog-message' className='confirm-dialog__message'>
          {message}
        </div>
        <div className='confirm-dialog__actions'>
          <Button variant='secondary' onClick={onCancel} size='md'>
            {cancelText}
          </Button>
          <Button variant={variant} onClick={onConfirm} size='md'>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.node.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['danger', 'warning', 'primary']),
};

export default ConfirmDialog;
